module.exports = __webpack_public_path__ + "img/element_bg.91a4699e.png";